export default "__VITE_ASSET__fa1384de__"